<template><div id="dev-component">
    <!-- Classroom Stat: {{ getClassroomId() }} -->
    <component :is="'production'" dev v-bind="{ ...devData }" :classroomId="classroomId" />
  </div>
</template>

<script>
import devData from "./data";

export default {
  components: {
    production: () => import("./index")
  },
  props: {
    classroomId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      devData
    }
  }
}
</script>
